

import { Icon } from "@chakra-ui/react";
import { IoMdCalendar, IoMdDocument } from "react-icons/io";
import {
  MdHome,
  MdInventory,
  MdList,
  MdNotificationsNone,
  MdPeople,
  MdSettings,
  MdStore
} from "react-icons/md";

import { useAuth } from "contexts/authContext";
import { lazy, Suspense } from "react";
import EmailList from "views/admin/Email Template/EmailList";
import LoginEntryList from "views/admin/LoggingEntries/LoginEntryList";
import OrgDetail from "views/admin/Organization/OrgDetail";
import UserProfile from "views/admin/userprofile/components/UserProfile";
import WithAuthProtection from "views/auth/withauthprotection/withauthprotection";
import LoctationAdmin from "views/admin/dashboards/locAdminDashboard";
//import LoctationAdmin from "views/admin/dashboards/locAdminDashboard";
const AddUser = lazy(() => import("views/admin/UserList/AddUser"));
// Lazy imports (only load when needed)
const VendorDetail = lazy(() => import("views/admin/vendors/VendorDetail"));
const VendorList = lazy(() => import("views/admin/vendors/VendorList"));
const VendorProduct = lazy(() => import("views/admin/vendors/VendorProducts"));
const VendorDashboard = lazy(() => import("views/admin/dashboards/VendorDashboard"));
const DashboardsDefault = lazy(() => import("views/admin/dashboards/default"));
const AssetList = lazy(() => import("views/admin/asset-management/AssetList"));
const CalibrationRecord = lazy(() => import("views/admin/Calibration/CalibrationRecord"));
const NotificationList = lazy(() => import("views/admin/notification/NotificationList"));
const OrgList = lazy(() => import("views/admin/Organization/OrgList"));
const Settings = lazy(() => import("views/admin/Settings"));
const UserMangement = lazy(() => import("views/admin/UserList"));
const DeptUserDashboard = lazy(() => import("views/admin/dashboards/deptuserDashboard"));
const OrgAdminDashboard = lazy(() => import("views/admin/dashboards/OrgAdminDashboard"));
const LocationAdmin = lazy(() => import("views/admin/dashboards/locAdminDashboard"));
const CertificateList = lazy(() => import("views/admin/Certificate/Certificate List/CertificateList"));
const AppointmentList = lazy(() => import("views/admin/Appointment Management/Appointment List/AppointmentList"));
const CreateAppointment = lazy(() => import("views/admin/Appointment Management/Create Appointment/CreateAppointment"));
const AppointmentDetailPage = lazy(() => import("views/admin/Appointment Management/Appointment Details/AppointmentDetails"));
const LeasedOrgList = lazy(() => import("views/admin/Organization/Component/Contractorlist"));
const AddLeasedOrg = lazy(() => import("views/admin/Organization/Component/AddContractor"));

const SuspenseWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div>Loading...</div>}>{children}</Suspense>
);

const vendorRoutes = [
  {
    name: "Dashboards",
    path: "/vendor-dashboard",
    icon: <Icon as={MdHome} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Vendor"]}>
        <SuspenseWrapper>
          <VendorDashboard />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Organizations",
    path: "/organizations/OrgList",
    icon: <Icon as={MdPeople} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}>
        <SuspenseWrapper>
          <OrgList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Vendor Details",
    path: "/vendorDetails",
    icon: <Icon as={MdStore} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "Vendor", "DeptUser", "OrgAdmin"]}>
        <SuspenseWrapper>
          <VendorDetail />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Products",
    path: "/vendorProducts",
    icon: <Icon as={MdStore} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "Vendor", "DeptUser", "OrgAdmin"]}>
        <SuspenseWrapper>
          <VendorProduct />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Assets",
    path: "/asset-management/assetList",
    icon: <Icon as={MdInventory} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}>
        <SuspenseWrapper>
          <AssetList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Calibrations",
    path: "/Calibration/calibrationRecord",
    icon: <Icon as={MdList} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}>
        <SuspenseWrapper>
          <CalibrationRecord />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Notification",
    path: "/notification/NotificationList",
    icon: <Icon as={MdNotificationsNone} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}>
        <SuspenseWrapper>
          <NotificationList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Appointment",
    path: "/AppointmentList",
    icon: <Icon as={IoMdCalendar} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}>
        <SuspenseWrapper>
          <AppointmentList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },


];

const adminRoutes = [
  {
    name: "Dashboards",
    path: "/dashboards",
    layout: "/admin",
    icon: <Icon as={MdHome} w="20px" h="20px" color="inherit" />,
    component: (
      <WithAuthProtection allowedRoles={["Admin"]}>
        <SuspenseWrapper>
          <DashboardsDefault />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Organizations",
    path: "/organizations/OrgList",
    icon: <Icon as={MdPeople} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <OrgList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Vendors",
    path: "/vendors",
    icon: <Icon as={MdStore} w="20px" h="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: "Vendor List",
        path: "/vendors/VendorList",
        layout: "/admin",
        component: (
          <WithAuthProtection allowedRoles={["Admin", "DeptUser", "OrgAdmin", "Vendor"]}>
            <SuspenseWrapper>
              <VendorList />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
      {
        name: "Products",
        layout: "/admin",
        path: "/vendors/VendorProduct",
        component: (
          <WithAuthProtection allowedRoles={["Admin", "Vendor", "OrgAdmin", "DeptUser"]}>
            <SuspenseWrapper>
              <VendorProduct />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
    ],
  },
  {
    name: "Assets",
    path: "/asset-management/assetList",
    icon: <Icon as={MdInventory} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}>
        <SuspenseWrapper>
          <AssetList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Calibrations",
    path: "/Calibration/calibrationRecord",
    layout: "/admin",
    icon: <Icon as={MdList} w="20px" h="20px" color="inherit" />,

    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <CalibrationRecord />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Certificate",
    path: "/CertificateList",
    icon: <Icon as={IoMdDocument} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <CertificateList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Contractors",
    path: "/organizations/ContractorsList",
    icon: <Icon as={MdPeople} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin"]}>
        <SuspenseWrapper>
          <LeasedOrgList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Appointment",
    path: "/AppointmentList",
    icon: <Icon as={IoMdCalendar} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <AppointmentList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Systems",
    path: "/system",
    icon: <Icon as={MdSettings} w="20px" h="20px" color="inherit" />,
    collapse: true,
    items: [
      {

        name: "Logs  ",
        layout: "/admin",
        path: "/system-logs/list",
        component: (
          <WithAuthProtection allowedRoles={["Admin"]}>
            <SuspenseWrapper>
              <LoginEntryList />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
      {
        name: "Notification",
        path: "/notification/NotificationList",
        icon: <Icon as={MdNotificationsNone} w="20px" h="20px" color="inherit" />,
        layout: "/admin",
        component: (
          <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
            <SuspenseWrapper>
              <NotificationList />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },

      {
        name: "Templates",
        layout: "/admin",
        path: "/Template/TemplateList",
        component: (
          <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
            <SuspenseWrapper>
              <EmailList />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
      {
        name: "User Profile",
        layout: "/admin",
        path: "/profile/UserProfile",
        component: (
          <WithAuthProtection allowedRoles={["Admin", "Vendor", "OrgAdmin", "DeptUser"]}>
            <SuspenseWrapper>
              <UserProfile />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
      {
        name: "User Management",
        layout: "/admin",
        path: "/UserList",
        component: (
          <WithAuthProtection allowedRoles={["Admin"]}>
            <SuspenseWrapper>
              <UserMangement />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
    ]
  },
]

const DeptRoutes = [
  {
    name: "Dashboards",
    path: "/deptuserDashboard",
    icon: <Icon as={MdHome} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["DeptUser"]}>
        <SuspenseWrapper>
          <DeptUserDashboard />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: " Org Details",
    path: "/organizations/OrgDetail",
    icon: <Icon as={MdPeople} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <OrgDetail />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Vendors",
    path: "/vendors/VendorList",
    icon: <Icon as={MdStore} w="20px" h="20px" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "DeptUser", "OrgAdmin", "Vendor"]}>
        <SuspenseWrapper>
          <VendorList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },

  {
    name: "Assets",
    path: "/asset-management/assetList",
    icon: <Icon as={MdInventory} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}>
        <SuspenseWrapper>
          <AssetList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Calibrations",
    path: "/Calibration/calibrationRecord",
    icon: <Icon as={MdList} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <CalibrationRecord />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Appointment",
    path: "/AppointmentList",
    icon: <Icon as={IoMdCalendar} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <AppointmentList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Notification",
    path: "/notification/NotificationList",
    icon: <Icon as={MdNotificationsNone} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}>
        <SuspenseWrapper>
          <NotificationList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
];

const OrgAdminRoutes = [
  {
    name: "Dashboards",
    path: "/orgadminDashboard",
    icon: <Icon as={MdHome} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <OrgAdminDashboard />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: " Org Details",
    path: "/organizations/OrgDetail",
    icon: <Icon as={MdPeople} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <OrgDetail />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Vendors",
    icon: <Icon as={MdStore} w="20px" h="20px" color="inherit" />,
    collapse: true,
    path: "/vendors",
    items: [
      {
        name: "Vendor List",
        path: "/vendors/VendorList",
        layout: "/admin",
        component: (
          <WithAuthProtection allowedRoles={["OrgAdmin"]}>
            <SuspenseWrapper>
              <VendorList />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
      {
        name: "Products",
        layout: "/admin",
        path: "/vendors/VendorProduct",
        component: (
          <WithAuthProtection allowedRoles={["OrgAdmin"]}>
            <SuspenseWrapper>
              <VendorProduct />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
    ],
  },
  {
    name: "Assets",
    path: "/asset-management/assetList",
    icon: <Icon as={MdInventory} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <AssetList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Calibrations",
    path: "/Calibration/calibrationRecord",
    icon: <Icon as={MdList} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <CalibrationRecord />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Contractors",
    path: "/organizations/ContractorsList",
    icon: <Icon as={MdPeople} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <LeasedOrgList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Appointment",
    path: "/AppointmentList",
    icon: <Icon as={IoMdCalendar} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <AppointmentList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Notification",
    path: "/notification/NotificationList",
    icon: <Icon as={MdNotificationsNone} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <NotificationList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "User Management",
    path: "/UserList",
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["OrgAdmin"]}>
        <SuspenseWrapper>
          <UserMangement />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
];

const LocationAdminRoutes = [
  {
    name: "Dashboards",
    path: "/locadminDashboard",
    icon: <Icon as={MdHome} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["LocationAdmin"]}>
        <SuspenseWrapper>
          <LocationAdmin />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: " Org Details",
    path: "/organizations/OrgDetail",
    icon: <Icon as={MdPeople} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["LocationAdmin"]}>
        <SuspenseWrapper>
          <OrgDetail />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Vendors",
    icon: <Icon as={MdStore} w="20px" h="20px" color="inherit" />,
    collapse: true,
    path: "/vendors",
    items: [
      {
        name: "Vendor List",
        path: "/vendors/VendorList",
        layout: "/admin",
        component: (
          <WithAuthProtection allowedRoles={["LocationAdmin"]}>
            <SuspenseWrapper>
              <VendorList />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
      {
        name: "Products",
        layout: "/admin",
        path: "/vendors/VendorProduct",
        component: (
          <WithAuthProtection allowedRoles={["LocationAdmin"]}>
            <SuspenseWrapper>
              <VendorProduct />
            </SuspenseWrapper>
          </WithAuthProtection>
        ),
      },
    ],
  },
  {
    name: "Assets",
    path: "/asset-management/assetList",
    icon: <Icon as={MdInventory} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["LocationAdmin"]}>
        <SuspenseWrapper>
          <AssetList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Calibrations",
    path: "/Calibration/calibrationRecord",
    icon: <Icon as={MdList} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["LocationAdmin"]}>
        <SuspenseWrapper>
          <CalibrationRecord />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Appointment",
    path: "/AppointmentList",
    icon: <Icon as={IoMdCalendar} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["LocationAdmin"]}>
        <SuspenseWrapper>
          <AppointmentList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "Notification",
    path: "/notification/NotificationList",
    icon: <Icon as={MdNotificationsNone} w="20px" h="20px" color="inherit" />,
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["LocationAdmin"]}>
        <SuspenseWrapper>
          <NotificationList />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
  {
    name: "User Management",
    path: "/UserList",
    layout: "/admin",
    component: (
      <WithAuthProtection allowedRoles={["LocationAdmin"]}>
        <SuspenseWrapper>
          <UserMangement />
        </SuspenseWrapper>
      </WithAuthProtection>
    ),
  },
];

const useRoutes = () => {
  const { user } = useAuth();

  if (user?.userRole === "Vendor" || user?.userRole === "VendorUser") {
    return vendorRoutes;
  } else if (user?.userRole === "DeptUser") {
    return DeptRoutes;
  } else if (user?.userRole === "OrgAdmin" || user?.userRole === "LeasedOrg") {
    return OrgAdminRoutes;
  } else if (user?.userRole === "LocationAdmin") {
    return LocationAdminRoutes;
  }
  else {
    return adminRoutes;
  }
};

export default useRoutes;